import Vitally from "../../../../contents/docs/cdp/sources/_snippets/source-vitally.mdx";
import * as React from 'react';
export default {
  Vitally,
  React
};